
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/special/ncc-rare",
      function () {
        return require("private-next-pages/special/ncc-rare/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/special/ncc-rare"])
      });
    }
  